import { lockBodyScroll, unlockBodyScroll } from '@shared/lib';

export function useOpenBasket(){
  const isBasketOpen = ref(false);

  const openBasket = () => {
    isBasketOpen.value = !isBasketOpen.value;
    // Лочим/разлочиваем скролл фона с компенсацией скроллбара (без «прыжка»).
    if (isBasketOpen.value) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  };
  return {
    openBasket,
  }
}
